import autoTable from "jspdf-autotable";
import { drawGrandTotal } from "./pohdrawGrandTotalpdf";
import { format } from "crypto-js";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;

    function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}



  const columnStyles = {
    0: { cellWidth: 30, halign: "left" },
    1: { cellWidth: 30, halign: "left" },
    2: { cellWidth: 30, halign: "right" },
    3: { cellWidth: 35, halign: "right" },
     4: { cellWidth: 35, halign: "right" },
      5: { cellWidth: 39, halign: "right" },
       6: { cellWidth: 38, halign: "right" },
       7: { cellWidth: 38, halign: "right" },
      
  };

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

  // ================= HEADER =================
  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_GROUP);
  doc.rect(14, startY - 10, 275, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_GROUP);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_GROUP);
  doc.text(` ${shop} Railway`, 20, startY - 5);

  // ================= DETAIL TABLE =================
  autoTable(doc, {
    startY,
...PDF_TABLE_STYLE,
    head: [[
      
      "Type of Coaches",
      "Sub Type of Coaches",
      "No of Coaches",
      "Mechanical Labour Cost",
      "Mechanical Material Cost",
      "Electrical Labour Cost",
      "Electrical Material Cost",
      "Total Cost",
    ]],

    body: rows.map((r) => [
      (r.pohtype),
      (r.pohsubtype),
      format(r.noofcoaches),
      format(r.Mech_LabourCost),
      format(r.Mech_MaterialCost),
      format(r.Elec_LabourCost),
      format(r.Elec_MaterialCost),
      format(r.totalcost),
    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,
  });

  // ================= DEPOT TOTAL =================
  const y = doc.lastAutoTable.finalY + 2;

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_TOTAL);
  doc.rect(14, y, 275, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_TOTAL);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_TOTAL);

  // Depot Total text
  doc.text(`${String(shop).trim()} TOTAL`, 16, y + 5);

  // Debit Total
  doc.text(format(total.noofcoaches),102, y + 5, {
    align: "right",
  });

  // Credit Total
  doc.text(format(total.Mech_LabourCost) , 138, y + 5, {
    align: "right",
  });

  // Labour Cost Total
  doc.text(format(total.Mech_MaterialCost), 173, y + 5, {
    align: "right",
  });

  doc.text(format(total.Elec_LabourCost), 208, y + 5, {
    align: "right",
  });

  // Material Cost Total
  doc.text(format(total.Elec_MaterialCost), 248, y + 5, {
    align: "right",
  });

  // Total Cost Total
  doc.text(format(total.totalcost), 286, y + 5, {
    align: "right",
  });

  // Reset text color
  doc.setTextColor(0);

// Reserve space after Depot Total
doc.lastAutoTable.finalY = y +  5;
//                 rectangle height ^   ^ extra space
}



